import { Col, Container, Row } from 'react-bootstrap';
import seal from '../_design/sass/img/city_seal_clr.png';

const Footer = () => {
  return (
    <footer className='mt-4'>
      <div className='footer-primary'>
        <div className='footer-primary-nav container' role='navigation'>
          {/* Nav links can go here */}
        </div>
      </div>
      <div className='footer-main'>
        <Container>
          <Row>
            <Col sm='6'>
              <div className='media footer-media'>
                <img
                  src={seal}
                  alt='City of Chicago'
                  className='align-self-center mr-3'
                />
                <div className='media-body align-self-center'>
                  <h3
                    className='mt-0'
                    style={{ fontFamily: '"Roboto",sans-serif' }}
                  >
                    City of Chicago
                  </h3>
                </div>
              </div>
            </Col>
            <Col sm='6'>
              <div className='footer-main-right'>
                {/* Removed to avoid angry tweets at BACP :^) */}
                {/* <div className='footer-social-links'>
                  <a
                    href='https://www.facebook.com/ChicagoMayorsOffice'
                    rel='noreferrer'
                    target='_blank'
                    title='Facebook'
                    aria-label='Facebook'
                  >
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                  <a
                    href='https://twitter.com/chicagosmayor'
                    title='Twitter'
                    rel='noreferrer'
                    target='_blank'
                    aria-label='Twitter'
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                  <a
                    href='https://www.youtube.com/channel/UCWelwzDLIRvdJ7NaLQfS14g'
                    rel='noreferrer'
                    target='_blank'
                    title='YouTube'
                    aria-label='YouTube'
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
